import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { ListingState } from '__generated__/athena/graphql';
import { formatStreetAddress } from 'components/marketplace/helpers/addressHelpers';
import { getDisplayPrice } from 'components/marketplace/helpers/displayPrice';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

import { PricingTraditional } from './Pricing';

type MiniMapProperty = Pick<
  MarketplaceProperty,
  | 'bathrooms'
  | 'bedrooms'
  | 'buyDirectPrice'
  | 'city'
  | 'displayBadge'
  | 'listPrice'
  | 'listingHistory'
  | 'listingState'
  | 'listingTags'
  | 'schoolDistricts'
  | 'sqFtTotalLiving'
  | 'state'
  | 'street'
  | 'unitNumber'
  | 'unitType'
  | 'zip'
>;

interface PropertySummaryProps {
  property: MiniMapProperty;
}
export const MiniMapPropertySummary = ({ property }: PropertySummaryProps) => {
  const formattedStreet = formatStreetAddress(
    property.street,
    property.unitType,
    property.unitNumber,
  );
  const locality = [property.city, property.state].filter(Boolean).join(', ');

  return (
    <Col className="lg:hidden">
      <Text as="h1" className="pb-6 text-subheader-xs font-normal text-od-content-primary">
        <Text as="span" className="text-subheader-xs font-normal">
          {formattedStreet}
        </Text>
        <br />
        <Text as="span" className="text-subheader-xs font-normal">
          {[locality, property.zip].filter(Boolean).join(' ')}
        </Text>
      </Text>
      <Col as="section">
        <PricingTraditional
          price={getDisplayPrice(property, 'listed')}
          isAvailableSoon={property.listingState === ListingState.AVAILABLE_SOON}
        />
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bedrooms} bds
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bathrooms} ba
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.sqFtTotalLiving} sqft
          </Text>
        </Row>
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {!!property.schoolDistricts.length && property.schoolDistricts.join(' & ')}
          </Text>
        </Row>
      </Col>
    </Col>
  );
};
